import { BlockToComponentMap } from 'app/features/shared/blocks'
import { BrandTabsBlockType, BrandTabsComponent } from './brand-tabs-block'
import { CategoryTabsBlockType, CategoryTabsComponent } from './category-tabs-block'
import { CollectionGridBlockType, CollectionGridContainer } from './collection-grid-block'
import { FeaturedOfferBlockType, FeaturedOfferComponent, canRenderFeaturedOfferBlock } from './featured-offer-block'
import { FeaturedOffersBlockType, FeaturedOffersComponent } from './featured-offers-block'
import { ForYouBlockType, ForYouComponent } from './for-you-block'
import { OfferCollectionBlockType, OfferCollectionComponent, canRenderOfferCollectionBlock } from './offer-collection-block'
import { OfferGridBlockType, OfferGridComponent } from './offer-grid-block'
import { SearchBlockType, SearchComponent, canRenderSearchBlock } from './search-block'

export const getOfferBlockMappings = (): BlockToComponentMap => ({
  [BrandTabsBlockType]: { Component: BrandTabsComponent },
  [CategoryTabsBlockType]: { Component: CategoryTabsComponent },
  [CollectionGridBlockType]: { Component: CollectionGridContainer },
  [FeaturedOfferBlockType]: { Component: FeaturedOfferComponent, canRender: canRenderFeaturedOfferBlock },
  [FeaturedOffersBlockType]: { Component: FeaturedOffersComponent },
  [ForYouBlockType]: { Component: ForYouComponent },
  [OfferCollectionBlockType]: { Component: OfferCollectionComponent, canRender: canRenderOfferCollectionBlock },
  [OfferGridBlockType]: { Component: OfferGridComponent },
  [SearchBlockType]: { Component: SearchComponent, canRender: canRenderSearchBlock },
})
